export const puzzles = [
  {
    id: 'puzzle2',
    name: 'Dicranurus monstrosus',
    italic: true,
    description: [
      ['Group', 'Odontopleurida'],
      ['Age', 'Devonian'],
      ['Country', 'Morocco'],
      ['Size', '5.5cm'],
      [
        'Display',
        '<a href="https://ssl.eas.ualberta.ca/museum-display/diversity_detail.php?id=79">Dynamic Diversity #79</a>'
      ],
      [
        'Description',
        'Few trilobite species have such curved spines.'
      ]
    ],
    model:
      '/assets/puzzles/dicranurus-monstrosus/solved.glb',
    image:
      '/assets/img/trilobites/dicranurus-monstrosus.jpg',
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    zoomBounds: [0.8, 1.8],
    connections: [
      {
        p1: {
          id: 'cephalon',
          position: [4, 28, 0]
        },
        p2: {
          id: 'segments-a',
          position: [-25, 28, 0]
        }
      },
      {
        p1: {
          id: 'segments-a',
          position: [10, 28, 0]
        },
        p2: {
          id: 'segments-b',
          position: [-60, -4, 0]
        }
      },
      {
        p1: {
          id: 'segments-b',
          position: [-30, -4, 0]
        },
        p2: {
          id: 'segments-c',
          position: [-57, 12, 0]
        }
      },
      {
        p1: {
          id: 'segments-c',
          position: [-30, 12, 0]
        },
        p2: {
          id: 'pygidium',
          position: [-20, 20, 0]
        }
      }
    ],
    groups: [
      {
        id: 'group1',
        position: [-100, 2, 0],
        pieces: [
          {
            id: 'cephalon',
            name: 'Cephalon',
            description: `Lorem ipsum dolor sit amet`,
            url:
              '/assets/puzzles/dicranurus-monstrosus/cephalon.glb',
            rotation: [0, 90, 0],
            position: [0, 0, 0]
          }
        ]
      },
      {
        id: 'group2',
        position: [0, 2, 150],
        pieces: [
          {
            id: 'segments-a',
            name: 'Segments',
            description: `Lorem ipsum dolor sit amet`,
            url:
              '/assets/puzzles/dicranurus-monstrosus/segments-a.glb',
            rotation: [0, 90, 0],
            position: [0, 0, 0]
          }
        ]
      },
      {
        id: 'group3',
        position: [0, 2, 0],
        pieces: [
          {
            id: 'segments-b',
            name: 'Segments',
            description: `Lorem ipsum dolor sit amet`,
            url:
              '/assets/puzzles/dicranurus-monstrosus/segments-b.glb',
            rotation: [0, 90, 0],
            position: [0, 32, 0]
          }
        ]
      },
      {
        id: 'group4',
        position: [0, 2, -150],
        pieces: [
          {
            id: 'segments-c',
            name: 'Segments',
            description: `Lorem ipsum dolor sit amet`,
            url:
              '/assets/puzzles/dicranurus-monstrosus/segments-c.glb',
            rotation: [0, 90, 0],
            position: [0, 18, 0]
          }
        ]
      },
      {
        id: 'group5',
        position: [100, 2, 0],
        pieces: [
          {
            id: 'pygidium',
            name: 'Pygidium',
            description: `Lorem ipsum dolor sit amet`,
            url:
              '/assets/puzzles/dicranurus-monstrosus/pygidium.glb',
            rotation: [0, 90, 0],
            position: [0, 10, 0]
          }
        ]
      }
    ]
  },
  {
    id: 'puzzle1',
    name: 'Drotops megalomanicus',
    italic: true,
    description: [
      ['Group', 'Phacopida'],
      ['Age', 'Devonian'],
      ['Country', 'Morocco'],
      ['Display', 'Discover Technology Display Drawer'],
      [
        'Description',
        'This trilobite has simple ornamentation and lacks spines.'
      ]
    ],
    model:
      '/assets/puzzles/drotops-megalomanicus/solved.glb',
    image:
      '/assets/img/trilobites/drotops-megalomanicus.jpg',
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    zoomBounds: [0.8, 1.8],
    connections: [
      {
        p1: {
          id: 'drotops1',
          position: [20, 28, 0]
        },
        p2: {
          id: 'drotops2',
          position: [-25, 28, 0]
        }
      },
      {
        p1: {
          id: 'drotops2',
          position: [10, 28, 0]
        },
        p2: {
          id: 'drotops3',
          position: [-30, 28, 0]
        }
      },
      {
        p1: {
          id: 'drotops3',
          position: [17, 28, 3]
        },
        p2: {
          id: 'drotops4',
          position: [-30, 28, 0]
        }
      },
      {
        p1: {
          id: 'drotops4',
          position: [10, 28, 0]
        },
        p2: {
          id: 'drotops5',
          position: [-34, 28, -3]
        }
      }
    ],
    groups: [
      {
        id: 'group1',
        position: [-100, 2, 0],
        pieces: [
          {
            id: 'drotops1',
            name: 'Cephalon',
            description: `Lorem ipsum dolor sit amet`,
            url:
              '/assets/puzzles/drotops-megalomanicus/cephalon.glb',
            rotation: [0, 90, 0],
            position: [0, 0, 0]
          }
        ]
      },
      {
        id: 'group2',
        position: [0, 2, 150],
        pieces: [
          {
            id: 'drotops2',
            name: 'Segments',
            description: `Lorem ipsum dolor sit amet`,
            url:
              '/assets/puzzles/drotops-megalomanicus/segments-a.glb',
            rotation: [0, 90, 0],
            position: [0, 0, 0]
          }
        ]
      },
      {
        id: 'group3',
        position: [0, 2, 0],
        pieces: [
          {
            id: 'drotops3',
            name: 'Segments',
            description: `Lorem ipsum dolor sit amet`,
            url:
              '/assets/puzzles/drotops-megalomanicus/segments-b.glb',
            rotation: [0, 90, 0],
            position: [0, 0, 0]
          }
        ]
      },
      {
        id: 'group4',
        position: [0, 2, -150],
        pieces: [
          {
            id: 'drotops4',
            name: 'Segments',
            description: `Lorem ipsum dolor sit amet`,
            url:
              '/assets/puzzles/drotops-megalomanicus/segments-c.glb',
            rotation: [0, 90, 0],
            position: [0, 0, 0]
          }
        ]
      },
      {
        id: 'group5',
        position: [100, 2, 0],
        pieces: [
          {
            id: 'drotops5',
            name: 'Pygidium',
            description: `Lorem ipsum dolor sit amet`,
            url:
              '/assets/puzzles/drotops-megalomanicus/pygidium.glb',
            rotation: [0, 90, 0],
            position: [0, 0, 0]
          }
        ]
      }
    ]
  },

  {
    id: 'puzzle3',
    name: 'Erbenochile',
    italic: true,
    description: [
      ['Group', 'Phacopida'],
      ['Age', 'Devonian'],
      ['Country', 'Morocco'],
      ['Display', 'Not on Display'],
      [
        'Description',
        'Long spines extend from the ends of the cephalon.'
      ]
    ],
    model: '/assets/puzzles/erbenochile/solved.glb',
    image: '/assets/img/trilobites/erbenochile.jpg',
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    zoomBounds: [0.8, 1.8],
    connections: [
      {
        p1: {
          id: 'cephalon',
          position: [-14, 28, 0]
        },
        p2: {
          id: 'segments-a',
          position: [-25, 18, 0]
        }
      },
      {
        p1: {
          id: 'segments-a',
          position: [10, 28, 0]
        },
        p2: {
          id: 'segments-b',
          position: [-17, 28, 0]
        }
      },
      {
        p1: {
          id: 'segments-b',
          position: [17, 28, 0]
        },
        p2: {
          id: 'segments-c',
          position: [-10, 38, 0]
        }
      },
      {
        p1: {
          id: 'segments-c',
          position: [10, 38, 0]
        },
        p2: {
          id: 'pygidium',
          position: [-28, 46, 0]
        }
      }
    ],
    groups: [
      {
        id: 'group1',
        position: [-100, 2, 0],
        pieces: [
          {
            id: 'cephalon',
            name: 'Cephalon',
            description: `Lorem ipsum dolor sit amet`,
            url: '/assets/puzzles/erbenochile/cephalon.glb',
            rotation: [0, 90, 0],
            position: [0, 0, 0]
          }
        ]
      },
      {
        id: 'group2',
        position: [0, 2, 150],
        pieces: [
          {
            id: 'segments-a',
            name: 'Segments',
            description: `Lorem ipsum dolor sit amet`,
            url:
              '/assets/puzzles/erbenochile/segments-a.glb',
            rotation: [0, 90, 0],
            position: [0, 10, 0]
          }
        ]
      },
      {
        id: 'group3',
        position: [0, 2, 0],
        pieces: [
          {
            id: 'segments-b',
            name: 'Segments',
            description: `Lorem ipsum dolor sit amet`,
            url:
              '/assets/puzzles/erbenochile/segments-b.glb',
            rotation: [0, 90, 0],
            position: [0, 10, 0]
          }
        ]
      },
      {
        id: 'group4',
        position: [0, 2, -150],
        pieces: [
          {
            id: 'segments-c',
            name: 'Segments',
            description: `Lorem ipsum dolor sit amet`,
            url:
              '/assets/puzzles/erbenochile/segments-c.glb',
            rotation: [0, 90, 0],
            position: [0, 0, 0]
          }
        ]
      },
      {
        id: 'group5',
        position: [100, 2, 0],
        pieces: [
          {
            id: 'pygidium',
            name: 'Pygidium',
            description: `Lorem ipsum dolor sit amet`,
            url: '/assets/puzzles/erbenochile/pygidium.glb',
            rotation: [0, 90, 0],
            position: [0, -8, 0]
          }
        ]
      }
    ]
  }
]
